// src/routes/AnalyticsRoutes.jsx
import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

// Import analytics pages
import AnalyticsDashboard from '../pages/analytics/Dashboard';
import CampaignAnalytics from '../pages/analytics/CampaignAnalytics';
import ContentAnalytics from '../pages/analytics/ContentAnalytics';
import SocialMediaAnalytics from '../pages/analytics/SocialMediaAnalytics';
import CustomReportBuilder from '../pages/analytics/CustomReportBuilder';
import AudienceAnalytics from '../pages/analytics/AudienceAnalytics';
import FinancialAnalytics from '../pages/analytics/FinancialAnalytics';
import UserActivityAnalytics from '../pages/analytics/UserActivityAnalytics';
import CompetitiveAnalytics from '../pages/analytics/CompetitiveAnalytics';
import RegionalAnalytics from '../pages/analytics/RegionalAnalytics';
import TaxAnalytics from '../pages/analytics/TaxAnalytics';

/**
 * Analytics Routes Component
 * 
 * Centralizes all analytics-related routes for the application.
 * This makes it easier to import and use in the main router.
 */
import AnalyticsIndex from '../pages/analytics/Index';

const AnalyticsRoutes = () => {
  return (
    <Routes>
      {/* Analytics Index */}
      <Route path="/" element={<AnalyticsIndex />} />
      
      {/* Dashboard */}
      <Route path="/dashboard" element={<AnalyticsDashboard />} />
      
      {/* Campaign Analytics */}
      <Route path="/campaigns" element={<CampaignAnalytics />} />
      <Route path="/campaigns/:id" element={<CampaignAnalytics />} />
      
      {/* Content Analytics */}
      <Route path="/content" element={<ContentAnalytics />} />
      
      {/* Tax Analytics */}
      <Route path="/tax" element={<TaxAnalytics />} />
      
      {/* Add other analytics routes here as they are implemented */}
      {/* Brand Analytics */}
      {/* <Route path="/brands" element={<BrandAnalytics />} /> */}
      {/* <Route path="/brands/:id" element={<BrandAnalytics />} /> */}
      
      {/* Client Analytics */}
      {/* <Route path="/clients" element={<ClientAnalytics />} /> */}
      {/* <Route path="/clients/:id" element={<ClientAnalytics />} /> */}
      
      {/* Social Media Analytics */}
      <Route path="/social" element={<SocialMediaAnalytics />} />
      
      {/* Audience Analytics */}
      <Route path="/audience" element={<AudienceAnalytics />} />
      
      {/* Financial Analytics */}
      <Route path="/financial" element={<FinancialAnalytics />} />
      
      {/* User Activity Analytics */}
      <Route path="/user-activity" element={<UserActivityAnalytics />} />
      
      {/* Competitive Analysis */}
      <Route path="/competitive" element={<CompetitiveAnalytics />} />
      
      {/* Regional Analytics */}
      <Route path="/regional" element={<RegionalAnalytics />} />
      
      {/* Performance Trends */}
      {/* <Route path="/trends" element={<TrendsAnalytics />} /> */}
      
      {/* Custom Reports */}
      <Route path="/custom-report" element={<CustomReportBuilder />} />
      
      {/* Redirect any other paths to the analytics index */}
      <Route path="*" element={<Navigate to="/analytics" replace />} />
    </Routes>
  );
};

export default AnalyticsRoutes;